/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {RouteTwoPanelBottomLayoutComponent} from '../common/directives/route-two-panel-layout.component';
import {PERMISSIONS} from "../../components/auth/auth-constants";
import {LocalNetworkInfo} from "../../components/session/local-network-info";
import _ from "lodash";
import {ProductFeedResource} from '../../components/api/resources/resource/product-feed.resource';

const listTemplate = '<adn-retail-product-list-page [list]="list" [showConversionTracking]="true"></adn-retail-product-list-page>';



export function retailProductStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('retail-products.retail-product', ProductFeedResource, '', 'app.adv', 'app', listTemplate);
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            extension: /*@ngInject*/ function() {
              return {
                func: function(ctrl, afterFill) {
                  if (afterFill) {
                    return;
                  }
                  const networkInfo = LocalNetworkInfo.obtain();
                  const activeFeedCount = _.filter(networkInfo.getInfo('productFeedProductCounts'), function(feed) {
                    return feed.productCount > 0;
                  }).length;
                  const merchantCount = _.size(networkInfo.getInfo('merchants'));
                  ctrl.showMerchantColumn = merchantCount > 1 || activeFeedCount > 1;
    
                  ctrl.retailProductFields = [{label: 'name', param: ''}];
                  if (ctrl.showMerchantColumn) {
                    ctrl.retailProductFields.push({param: '', label: 'merchant'});
                  }
                  ctrl.retailProductFields.push({param: '', label: 'brand'}, {param: '', label: 'image'}, {param: '', label: 'price'}, {param: '', label: 'conversionPixel'});
                  ctrl.merchantGuide = networkInfo.getMerchantGuide();
                  ctrl.showConversionTracking = true;
                  ctrl.defaultFields = ctrl.retailProductFields;
                  ctrl.sel = {selFields: ctrl.defaultFields};
                }
              };
            },
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey);
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            views: {
              'content@app': {
                component: RouteTwoPanelBottomLayoutComponent
              },
              'context@app': {component: AdminResourceContextRoutePageComponent}
            }
          }, 'RetailProduct'));
  }, adnRouterHelper);
}
